import { useAppStore } from '@/store/app';
let tokenProvider = null;
export function setAuthTokenProvider(provider) {
    tokenProvider = provider;
}
export async function getAuthToken() {
    if (tokenProvider) {
        const token = await tokenProvider();
        useAppStore.getState().setAuthToken(token);
        return token;
    }
    return useAppStore.getState().authToken;
}
